import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { Dispatch } from 'redux';

import { StoreState } from '../../../reducers';
import { ListDisplayType } from '../../../containers/DriveItemList/constants';
import { setFolderDisplayType } from '../../../containers/DriveItemList/actions';
import Menu, { MenuConfig } from '../../DropdownMenu';
import { Wrapper, Button } from './styles';
import Utils from '../../../utils';
import useClickOutside from '../../../utils/customHooks/useClickOutside';

interface DisplayTypeDropdownProps {
	displayType: ListDisplayType;
	folderId?: number;
	dispatch: Dispatch<StoreState>;
}

const DisplayTypeDropdown = ({ displayType, folderId, dispatch }: DisplayTypeDropdownProps) => {
	const wrapperElement = React.useRef<HTMLDivElement>(null);
	const [isMenuDisplayed, setIsMenuDisplayed] = React.useState(false);
	useClickOutside(wrapperElement, isMenuDisplayed, () => setIsMenuDisplayed(false));

	const config: MenuConfig = Object.values(ListDisplayType).reduce((acc, current) => {
		if (current === ListDisplayType.Default) {
			return acc;
		}

		acc[current] = {
			label: I18n.t(`messages.${current.toLowerCase()}`),
			icon: `iconset_uprez_${current.toLowerCase()}`,
			isActive: displayType === current,
			onClick: () => {
				dispatch(setFolderDisplayType(folderId, current));
				setIsMenuDisplayed(false);
			},
			hasSeparator: true,
		};
		return acc;
	}, {});

	return (
		<Wrapper ref={wrapperElement} className="DisplayTypeDropdown">
			<Button
				className="DisplayTypeDropdown"
				type="button"
				isMenuDisplayed={isMenuDisplayed}
				onClick={() => setIsMenuDisplayed(prevState => !prevState)}
			>
				<Translate value="messages.view" />
				{Utils.getSvgIcon('iconset_triangle-1')}
			</Button>
			<Menu
				config={config}
				isDisplayed={isMenuDisplayed}
			/>
		</Wrapper>
	);
};

export default DisplayTypeDropdown;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/DisplayTypeDropdown/index.tsx